import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastsContainer } from './toast/toast.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ArticoloViewComponent } from './articolo-view/articolo-view.component';



@NgModule({
  declarations: [ToastsContainer, ArticoloViewComponent],
  imports: [
    CommonModule,
    NgbToastModule
  ],
  exports: [
    ToastsContainer,ArticoloViewComponent 
  ]
})
export class SharedModule { }
